/* eslint-disable no-alert, no-console */
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "utils/api-client-wrapper";
import type { GetV1UsersMeQueryResponse } from "../../../types/GetV1UsersMe.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "utils/api-client-wrapper";

function getGetV1UsersMeUrlClient() {
  const res = { method: 'GET', url: `/v1/users/me` as const }
  return res
}

/**
 * @summary Get current user details
 * {@link /v1/users/me}
 */
export async function getV1UsersMeClient(config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<GetV1UsersMeQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getGetV1UsersMeUrlClient().url.toString(), ... requestConfig })
  return res
}